<template>
  <div :class="`font-game bg-${color || 'green'}-500 cursor-pointer hover:bg-${color || 'green'}-600 duration-150 p-2 text-white rounded-sm`">{{label}}</div>
</template>

<script>
import { ref } from 'vue'


export default {
  name: 'Button',
  components:{
  },
  props: {
    label: String,
    color: { type: String, default: 'green' }
  }
}
</script>

